import type { ProjectStorage } from './ProjectStorage';
import { LocalProjectStorage } from './LocalProjectStorage';
import { RemoteProjectStorage } from './RemoteProjectStorage';
import type { StorageConfig } from './storageConfig';

export function createProjectStorage<TLevel>(config: StorageConfig): ProjectStorage<TLevel> {
  switch (config.mode) {
    case 'local':
      return new LocalProjectStorage<TLevel>(config);
    case 'remote':
      return new RemoteProjectStorage<TLevel>(config);
    default:
      throw new Error(`Unknown storage mode: ${(config as StorageConfig).mode}`);
  }
}
